import { Provider } from "react-redux"
import ReactDOM from "react-dom/client"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { store } from "./redux/store"
import "./index.scss"
import { injectStore } from "./common/utils"

injectStore(store)

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <Provider store={store}>
    <App />
  </Provider>
)

if (process.env.REACT_APP_ENV !== "production") {
  reportWebVitals(console.log)
}
